import PageHeader from "src/components/PageHeader";
import OrderCard from "./components/OrderCard";
import { useContext, useEffect, useState } from "react";
import { getData } from "src/actions/getData";
import Skeleton from "react-loading-skeleton";
import processingContext from "src/context/processingContext";

export default function NonTehranOrders() {
  const [nonTehranOrders, setNonTehranOrders] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;

  const { processingOrders, setProcessingOrders, inboundProducts, setInboundProducts } = useContext(processingContext);

  useEffect(() => {
    if (!processingOrders) {
      getData(setProcessingOrders, "/orders/by-status/processing");
    }
    if (!inboundProducts) {
      getData(setInboundProducts, "/inbounds/products");
    }
  }, []);

  useEffect(() => {
    if (processingOrders) {
      setNonTehranOrders(
        processingOrders.filter((order) => order.city !== "تهران")
      );
    }
  }, [processingOrders]);

  const totalPages = nonTehranOrders
    ? Math.ceil(nonTehranOrders.length / itemsPerPage)
    : 0;

  const paginatedOrders = nonTehranOrders
    ? nonTehranOrders
      .sort((a, b) => a.id - b.id)
      .slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage)
    : [];

  return (
    <>
      <PageHeader
        btnTitle={`${nonTehranOrders?.length || "-"} سفارش`}
        title="سفارشات شهرستان"
      />

      {nonTehranOrders ? (
        nonTehranOrders.length > 0 ? (
          <>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-3">
              {paginatedOrders.map((order, index) => (
                <OrderCard order={order} inboundProducts={inboundProducts} type="nonTehran" key={`${order.id}-${currentPage}`} />
              ))}
            </div>

            {/* Pagination Controls */}
            <div className="flex justify-center items-center gap-4 mt-6">
              <button
                disabled={currentPage === 1}
                onClick={() => setCurrentPage((prev) => prev - 1)}
                className="px-4 py-2 rounded-lg bg-gray-200 disabled:opacity-50"
              >
                قبلی
              </button>
              <span>
                صفحه {currentPage} از {totalPages}
              </span>
              <button
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage((prev) => prev + 1)}
                className="px-4 py-2 rounded-lg bg-gray-200 disabled:opacity-50"
              >
                بعدی
              </button>
            </div>
          </>
        ) : (
          <div className="w-full h-60 flex justify-center items-center bg-white p-4 rounded-xl">
            هیچ سفارشی برای تحویل شهرستان وجود ندارد
          </div>
        )
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-3">
          {Array.from({ length: 8 }).map((_, i) => (
            <Skeleton key={i} height={430} className="!rounded-xl" />
          ))}
        </div>
      )}
    </>
  );
}
